const COLORS = {
    GRAY: "#adadad",
    GREEN: "#34c759",
    SEAGREEN: "#389D97"
  };
  
  export default COLORS;